import Grid from "@mui/material/Grid";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import {FormAlertModel} from "../../../api/types/alert";
import {SelectElementModelBE, SelectElementModelFE} from "../../../api/types/generic";
import {FormAutocomplete} from "../../../common/form-fields";
import {alertsAtom, initialFormAlertModel} from "../../../state/alertRecoil";
import AdvanceBookingForm from "./AdvanceBookingForm";
import AvailabilityOfVehiclesForm from "./AvailabilityOfVehiclesForm";
import CapacityOfLocationsForm from "./CapacityOfLocationsForm";
import CompetitorsBenchmarksForm from "./CompetitorsBenchmarksForm";
import PricingErrorsForm from "./PricingErrorsForm";
import RpdForm from "./RpdForm";
import {useContext} from "react";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

type AlertFormHandlerProps = {
    activeStep: Number;
    readonly: boolean;
};

const AlertFormsHandler = ({activeStep, readonly}: AlertFormHandlerProps) => {
    //USE TRANSLATION
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Context
    const {dispatchGlobalData, globalData: {user}} = useContext(GlobalContext);

    //setto tutte le legalEntities options e le passo al filtro di ricerca ["all", "drivalia_it","drivalia_fr"]
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const everyLegalEntitiesWithoutAll = legalEntityOptions
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //setto tutti i dealers options
    const dealerOption: SelectElementModelFE[] = user.dealers?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const dealerFilteredOptions = dealerOption
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //USE FORM CONTEXT
    const {register, watch, reset} = useFormContext<FormAlertModel>();

    // Use Recoil
    const [alertsList] = useRecoilState(alertsAtom);

    {
        /* SWITCH PER RENDERIZZARE I VARI FORM */
    }
    const renderAlertForm = () => {
        switch (watch("type")?.label) {
            case "Capacity of the locations and fleet utilization":
                return <CapacityOfLocationsForm readonly={readonly}/>;
            case "Availability of vehicles in the locations and fleet utilization":
                return <AvailabilityOfVehiclesForm readonly={readonly}/>;
            case "Competitors benchmarks":
                return <CompetitorsBenchmarksForm readonly={readonly}/>;
            case "Revenue per day for locations and pick-up date":
                return <RpdForm readonly={readonly}/>;
            case "Pricing errors":
                return <PricingErrorsForm readonly={readonly}/>;
            case "Advance booking":
                return <AdvanceBookingForm readonly={readonly}/>;
            default:
                break;
        }
    };

    return (
        <Grid container spacing={2} alignItems="start">
            {/* ALERT TYPE SELEZIONATO */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("type")}
                    label={
                        activeStep === 0
                            ? `${t("pricing:alert.labels.alertType")}*`
                            : activeStep === 1
                                ? t("pricing:alert.labels.alertSelected")
                                : ""
                    }
                    options={alertsList}
                    isOptionEqualToValue={(
                        option: SelectElementModelFE,
                        value: SelectElementModelFE
                    ) => option.code === value.code}
                    readOnly={readonly || activeStep === 1}
                    handleChange={(value: SelectElementModelFE) => {
                        reset({
                            ...initialFormAlertModel(t, legalEntityOptions, dealerOption),
                            type: value,
                        });
                    }}
                />
            </Grid>

            {/* SWITCH PER RENDERIZZARE I VARI FORM */}
            {activeStep === 1 ? renderAlertForm() : ""}
        </Grid>
    );
};

export default AlertFormsHandler;
